/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import Table from '../Table/Table';
import moment from 'moment';
import { ChevronDoubleDownIcon } from '@heroicons/react/24/outline';
import queryString from 'query-string';
import classNames from 'classnames';
import ReactPaginate from 'react-paginate';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import request from '../../utils/APIHelper/request';
import loadingGif from '../../assets/Other/loading.gif';
import {
  convertStringToInt,
  convertStringToNumber,
} from '../../utils/ConvertStringToNumber/convertStringToNumber';
import ParcelRatesFilters from './Filters/ParcelRatesFilter';
import ParcelRateCell from './Inputs/ParcelRateCell';
import DoubleParcelRatesCell from './Inputs/DoubleParcelRateCell';
import ParcelRateSelectCell from './Inputs/ParcelRateSelectCell';
import { toast } from 'react-toastify';
import { currentUser } from '../../utils/Auth/auth';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ParcelRatesCreatingWindow from './ParcelRatesCreatingWindow';
import ParcelRatesDeactivationWindow from './ParcelRatesDeactivationWindow';

const dateTimeRow = (value) => {
  if (!value) return '---';
  return (
    <div>
      <div>{moment(value).format('MMM DD, YYYY')}</div>
      <div>{moment(value).format('hh:mmA')}</div>
    </div>
  );
};

const ParcelRatesEditTable = () => {
  const { search } = useLocation();
  const params = queryString.parse(search);

  const swalModal = withReactContent(Swal);

  const [updateTableLoading, setUpdateTableLoadig] = useState(false);

  const defaultRateFilter = {
    id: params.id || null,
    branchId: params.branchId || null,
    agent: params.agent || null,
    country: params.country || null,
    rateName: params.rateName || null,
    weightCode: params.weightCode || null,
    weightFrom: params.weightFrom || null,
    weightTo: params.weightTo || null,
    status: params.status || null,
    statusFrom: params.statusFrom || null,
    statusTo: params.statusTo || null,
    sae: params.sae || null,
    deliveryModeCode: params.deliveryModeCode || null,
    perKgA: params.perKgA || null,
    perKgW: params.perKgW || null,
    perKgM: params.perKgM || null,
    perEachA: params.perEachA || null,
    perEachW: params.perEachW || null,
    perEachM: params.perEachM || null,
    deliveryM: params.deliveryM || null,
    deliveryA: params.deliveryA || null,
    deliveryW: params.deliveryW || null,
    insuranceM: params.insuranceM || null,
    insuranceW: params.insuranceW || null,
    insuranceA: params.insuranceA || null,
    packagingM: params.packagingM || null,
    packagingW: params.packagingW || null,
    packagingA: params.packagingA || null,
    firstDateTime: params.firstDateTime || null,
    editDateTime: params.editDateTime || null,
    source: params.source || null,
  };

  const [filter, setFilter] = useState(defaultRateFilter);
  const [pageLoading, setPageLoading] = useState(false);

  const navigate = useNavigate();
  const [originalData, setOriginalData] = useState();
  const [totalItems, setTotalItems] = useState();
  const [totalPages, setTotalPages] = useState();
  const [recentlyUpdatedData, setrecentlyUpdatedData] = useState([]);
  const [data, setData] = useState([]);

  const [addingNewRateWindow, setAddingNewRateWindow] = useState();

  const updateFilter = (agentCode, status = 'Active') => {
    setFilter({ ...defaultRateFilter, agent: agentCode, status });
  };

  const copyRatesByParams = () => {
    swalModal.fire({
      title: 'Copy active rates by params',
      text: `Copy rates by params`,
      html: (
        <ParcelRatesCreatingWindow
          navigate={navigate}
          updateFilter={updateFilter}
        />
      ),
      showCancelButton: false,
      showConfirmButton: false,
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-[400px] text-sm',
      },
    });
  };

  const deactivateRatesByParams = () => {
    swalModal.fire({
      title: 'Deactivate active rates for:',
      text: `Deactivate active rates for:`,
      html: (
        <ParcelRatesDeactivationWindow
          navigate={navigate}
          updateFilter={updateFilter}
        />
      ),
      showCancelButton: false,
      showConfirmButton: false,
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-[400px] text-sm',
      },
    });
  };

  const getOptionByBranch = (ca, us) => {
    if (currentUser.baseBranch === '1') return ca;
    return us;
  };

  const addNewRateLine = () => {
    const newRate = {
      id: null,
      branchId: currentUser.baseBranch,
      agent: params.agent || null,
      country: params.country || null,
      rateName: params.rateName || 'Regular',
      weightCode: params.weightCode || getOptionByBranch('kg', 'lbs'),
      weightFrom: params.weightFrom || getOptionByBranch(4.51, 10),
      weightTo: params.weightTo || getOptionByBranch(30, 66),
      status: params.status || 'Active',
      statusFrom: params.statusFrom || new Date(),
      statusTo: params.statusTo || new Date(2100, 1, 1),
      sae: params.sae || 'Air',
      deliveryModeCode: params.deliveryModeCode || 'R',
      perKgA: params.perKgA || 0,
      perKgW: params.perKgW || 0,
      perKgM: params.perKgM || 0,
      perEachA: params.perEachA || 0,
      perEachW: params.perEachW || 0,
      perEachM: params.perEachM || 0,
      deliveryM: params.deliveryM || 0,
      deliveryA: params.deliveryA || 0,
      deliveryW: params.deliveryW || 0,
      insuranceM: params.insuranceM || 0,
      insuranceW: params.insuranceW || 0,
      insuranceA: params.insuranceA || 0,
      packagingM: params.packagingM || 0,
      packagingW: params.packagingW || 0,
      packagingA: params.packagingA || 0,
      firstDateTime: null,
      editDateTime: null,
      source: null,
    };
    setData((prevData) => [newRate, ...prevData]);
    setrecentlyUpdatedData((prevData) => [newRate, ...prevData]);
    setOriginalData((prevData) => [[], ...prevData]);
  };

  const syncTableWithNewData = (currentData, newData) => {
    let resultData = [];
    if (!currentData.some((item) => !item?.id)) resultData = currentData;
    else {
      const newRows = newData.filter(
        (item) => !currentData.some((rate) => rate.id === item?.id),
      );
      const previousData = currentData.filter((item) => !!item.id);

      resultData = [...newRows, ...previousData];
    }

    return resultData;
  };

  const setFilterValue = (field, currentValue, type = 'string') => {
    let value = '';
    switch (type) {
      case 'number':
        value = convertStringToNumber(currentValue, true);
        break;
      case 'number-int':
        value = convertStringToInt(currentValue, true);
        break;
      default:
        value = currentValue;
    }

    if (value === '' || (type === 'number' && isNaN(value))) {
      value = null;
    }

    setFilter((prevFilter) => ({
      ...prevFilter,
      [field]: value,
    }));
  };
  const statuses = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Archived', value: 'Archive' },
    { label: 'Duplicated', value: 'duplicated' },
  ];
  const branches = [
    {
      label: '1',
      value: 1,
      isDisabled:
        !currentUser?.branches?.includes('1') &&
        !currentUser?.baseBranch?.includes('1'),
    },
    {
      label: '2',
      value: 2,
      isDisabled:
        !currentUser?.branches?.includes('2') &&
        !currentUser?.baseBranch?.includes('2'),
    },
    {
      label: '3',
      value: 3,
      isDisabled:
        !currentUser?.branches?.includes('3') &&
        !currentUser?.baseBranch?.includes('3'),
    },
    {
      label: '4',
      value: 4,
      isDisabled:
        !currentUser?.branches?.includes('4') &&
        !currentUser?.baseBranch?.includes('4'),
    },
  ];
  const weightUnits = [
    { label: 'kg', value: 'kg' },
    { label: 'lbs', value: 'lbs' },
  ];
  const seaAir = [
    { label: 'Air', value: 'Air' },
    { label: 'Sea', value: 'Sea' },
  ];
  const deliveryModeCodes = [
    { label: 'R', value: 'R' },
    { label: 'PU', value: 'PU' },
    { label: 'E', value: 'E' },
    { label: 'PME', value: 'PME' },
    { label: 'RP', value: 'RP' },
  ];

  const transformData = (data) => {
    return data?.map((item, index) => ({
      id: (
        <div
          className={classNames(
            (!item?.id || item?.id !== originalData[index]?.id) &&
              'text-green-500',
          )}
        >
          {item?.id || 'NEW'}
        </div>
      ),
      // branchId: item?.branchId,
      branchId: ParcelRateSelectCell({
        type: 'number',
        field: 'branchId',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-20',
        options: branches,
        isNew: !item?.id,
      }),
      agent: ParcelRateCell({
        field: 'agent',
        data,
        setData,
        index,
        recentlyUpdatedData,
        originalData,
        customClassName: 'max-w-14 uppercase',
        maxLength: 6,
        isNew: !item?.id,
      }),
      country: ParcelRateCell({
        field: 'country',
        data,
        setData,
        index,
        recentlyUpdatedData,
        originalData,
        customClassName: 'max-w-11 uppercase',
        maxLength: 3,
        isNew: !item?.id,
      }),
      rateName: ParcelRateCell({
        field: 'rateName',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-20',
        isNew: !item?.id,
      }),
      // weightCode: item?.weightCode,
      weightCode: ParcelRateSelectCell({
        field: 'weightCode',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-20',
        options: weightUnits,
        isNew: !item?.id,
      }),
      weight: DoubleParcelRatesCell({
        name: 'From',
        name2: 'to',
        field: 'weightFrom',
        field2: 'weightTo',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-12 m-0',
        type: 'number',
        isNew: !item?.id,
      }),
      // status: item?.status,
      status: ParcelRateSelectCell({
        field: 'status',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-20 min-w-24',
        options: statuses,
        isNew: !item?.id,
      }),
      statusFrom: DoubleParcelRatesCell({
        name: 'From',
        name2: 'To',
        field: 'statusFrom',
        field2: 'statusTo',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'm-0',
        type: 'date',
        isNew: !item?.id,
      }),
      // sae: item?.sae,
      sae: ParcelRateSelectCell({
        field: 'sae',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-20',
        options: seaAir,
        isNew: !item?.id,
      }),
      // deliveryModeCode: item?.deliveryModeCode,
      deliveryModeCode: ParcelRateSelectCell({
        field: 'deliveryModeCode',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-20',
        options: deliveryModeCodes,
        isNew: !item?.id,
      }),
      perKg: DoubleParcelRatesCell({
        name: 'Meest',
        name2: 'Agent',
        field: 'perKgM',
        field2: 'perKgA',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-12 m-0',
        type: 'number',
        isNew: !item?.id,
      }),
      perEach: DoubleParcelRatesCell({
        name: 'Meest',
        name2: 'Agent',
        field: 'perEachM',
        field2: 'perEachA',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-12 m-0',
        type: 'number',
        isNew: !item?.id,
      }),
      delivery: DoubleParcelRatesCell({
        name: 'Meest',
        name2: 'Agent',
        field: 'deliveryM',
        field2: 'deliveryA',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-12 m-0',
        type: 'number',
        isNew: !item?.id,
      }),
      insurance: DoubleParcelRatesCell({
        name: 'Meest',
        name2: 'Agent',
        field: 'insuranceM',
        field2: 'insuranceA',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-12 m-0',
        type: 'number-int',
        nullable: true,
        isNew: !item?.id,
      }),
      packaging: DoubleParcelRatesCell({
        name: 'Meest',
        name2: 'Agent',
        field: 'packagingM',
        field2: 'packagingA',
        data,
        setData,
        originalData,
        index,
        recentlyUpdatedData,
        customClassName: 'max-w-12 m-0',
        type: 'number-int',
        nullable: true,
        isNew: !item?.id,
      }),
      firstDateTime: (
        <div
          className={classNames(
            item?.firstDateTime !== originalData[index]?.firstDateTime &&
              'bg-green-200',
            !item.id && 'bg-red-200',
          )}
        >
          {dateTimeRow(item?.firstDateTime)}
        </div>
      ),
      editDateTime: (
        <div
          className={classNames(
            item?.editDateTime !== originalData[index]?.editDateTime &&
              'bg-green-200',
            !item.id && 'bg-red-200',
          )}
        >
          {dateTimeRow(item?.editDateTime)}
        </div>
      ),
      source: (
        <div
          className={classNames(
            (!item?.source || item?.source !== originalData[index]?.source) &&
              'text-green-500',
            !item.id && 'bg-red-200',
          )}
        >
          {item?.source || '---'}
        </div>
      ),
    }));
  };

  const headerWitchIcons = (headerName) => {
    return (
      <div className="relative text-xs">
        <div>{headerName}</div>
        <div>
          <ChevronDoubleDownIcon className="w-5 h-5 mx-auto text-blue-900" />
        </div>
      </div>
    );
  };

  const headers = [
    headerWitchIcons('Id'),
    headerWitchIcons('Branch'),
    headerWitchIcons('Agent'),
    headerWitchIcons('Country'),
    headerWitchIcons('Rate Name'),
    headerWitchIcons('Unit'),
    headerWitchIcons('Weight'),
    headerWitchIcons('Status'),
    headerWitchIcons('Active'),
    headerWitchIcons('Sea/Air'),
    headerWitchIcons('Delivery Mode'),
    // { element: 'delivery Mode', columnClassName: 'p-0' },
    headerWitchIcons('per kg/lb'),
    headerWitchIcons('Per Each'),
    headerWitchIcons('Delivery'),
    headerWitchIcons('Insurance'),
    headerWitchIcons('Packaging'),
    headerWitchIcons('Reg-tion Date'),
    headerWitchIcons('Edit Date'),
    headerWitchIcons('Source'),
  ];

  const getQueryParamsByPage = (pageNum) => {
    return {
      ...{ page: pageNum },
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await getParcelRates(params.page);
      setTotalItems(result?.totalItems);
      setTotalPages(result?.totalPages);

      setOriginalData(result?.parcelRates);
      setData(result?.parcelRates);
      setrecentlyUpdatedData(result?.parcelRates);
    };
    fetchData();
  }, [search]);

  const getParcelRates = async (page = 1) => {
    const result = await request({
      url: `${controllers.parcelRates}getParcelRatesByParams`,
      type: requestTypes.post,
      params: { page },
      body: filter,
      disableLogOut: true,
      setLoading: setPageLoading,
    });
    return result;
  };

  const applyFilters = () => {
    const settedFilterFields = Object.fromEntries(
      Object.entries(filter).filter(
        ([, value]) => value !== null && value !== undefined,
      ),
    );

    // Convert to query string
    const query = queryString.stringify(settedFilterFields);

    // Redirect to the page
    navigate(`/parcelRates?${query}`);
  };

  const filters = () => {
    return (
      <>
        <div className="mx-5">Filters:</div>
        <div className="flex flex-wrap items-center">
          <ParcelRatesFilters setFilterValue={setFilterValue} filter={filter} />
        </div>
        <div className="text-center">
          <div
            onClick={applyFilters}
            className="inline-block bg-blue-900 hover:bg-blue-800 text-white px-3 py-1 rounded-full cursor-pointer hover:transition-all hover:duration-30"
          >
            Apply Filters
          </div>
        </div>
      </>
    );
  };

  const updateParcelRatesAPICall = async (body) => {
    const response = await request({
      url: `${controllers.parcelRates}updateParcelRatesTable`,
      type: requestTypes.post,
      body,
      disableLogOut: true,
      setLoading: setUpdateTableLoadig,
    });
    // syncTableWithNewData(response.result);

    return response;
  };

  const updateRates = async () => {
    if (JSON.stringify(data) !== JSON.stringify(recentlyUpdatedData)) {
      const changedRows = data.reduce((acc, item, index) => {
        if (item !== recentlyUpdatedData[index]) {
          acc.push(item);
        }
        return acc;
      }, []);
      if (!changedRows.length) return;

      const response = await updateParcelRatesAPICall(changedRows);
      if (response?.code === responseTypes.success) {
        const changedRowsIds = new Set(changedRows.map((i) => i.id));
        const syncedData = syncTableWithNewData(data, response.result);
        const newData = syncedData.map((item) =>
          changedRowsIds.has(item?.id)
            ? { ...item, editDateTime: new Date() }
            : item,
        );
        setData(newData);
        setrecentlyUpdatedData(newData);
        // console.log(
        //   'updated data: ',
        //   originalData,
        //   '\nnew data: ',
        //   newData,
        //   '\nsynced data: ',
        //   syncedData,
        //   '\ndata: ',
        //   data,
        // );
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    }
  };

  const isReadyToSave = () => {
    const hasNewRows = data.some((item) => !item?.id);
    return (
      JSON.stringify(data) !== JSON.stringify(recentlyUpdatedData) || hasNewRows
    );
  };

  const clearTable = () => {
    if (isReadyToSave()) {
      const newData = recentlyUpdatedData.filter((i) => !!i.id);
      setData(newData);
      setrecentlyUpdatedData(newData);
      const lengthDiff = newData?.length - originalData?.length;
      setOriginalData(originalData.splice(-lengthDiff));
    }
  };

  return (
    <div>
      {filters()}
      <div className="min-h-[4.5rem] mt-16 mx-4">
        {addingNewRateWindow ? (
          <>
            Add new/update rates
            <div
              onClick={() => setAddingNewRateWindow(false)}
              data-tooltip-id="agent-adding-tooltip"
              className="cursor-pointer bg-blue-400 text-white rounded-full h-6 w-6 inline-flex items-center justify-center pb-[2px] mx-2 hover:bg-blue-300 hover:transition-all hover:duration-300"
            >
              -
            </div>
            <span className="mx-5 font-semibold">Options: </span>
            <div className="mt-5">
              <div className="inline-block">
                Add new line
                <div
                  onClick={addNewRateLine}
                  data-tooltip-id="agent-adding-tooltip"
                  className="cursor-pointer bg-blue-900 text-white rounded-full h-6 w-6 inline-flex items-center justify-center pb-[2px] mx-2 hover:bg-blue-800 hover:transition-all hover:duration-300"
                >
                  +
                </div>
              </div>
              <div className="ml-12 inline-block">
                Copy by params
                <div
                  onClick={copyRatesByParams}
                  data-tooltip-id="agent-adding-tooltip"
                  className="cursor-pointer bg-blue-900 text-white rounded-full h-6 w-6 inline-flex items-center justify-center pb-[2px] mx-2 hover:bg-blue-800 hover:transition-all hover:duration-300"
                >
                  +
                </div>
              </div>
              <div className="ml-12 inline-block">
                Deactivate by params
                <div
                  onClick={deactivateRatesByParams}
                  data-tooltip-id="agent-adding-tooltip"
                  className="cursor-pointer bg-blue-900 text-white rounded-full h-6 w-6 inline-flex items-center justify-center pb-[2px] mx-2 hover:bg-blue-800 hover:transition-all hover:duration-300"
                >
                  {' '}
                  +
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            Add new/update rates
            <div
              onClick={() => setAddingNewRateWindow(true)}
              data-tooltip-id="agent-adding-tooltip"
              className="cursor-pointer bg-blue-900 text-white rounded-full h-6 w-6 inline-flex items-center justify-center pb-[2px] mx-2 hover:bg-blue-800 hover:transition-all hover:duration-300"
            >
              +
            </div>
          </>
        )}
      </div>
      <div className="m-5">Total: {totalItems}</div>
      <div className="mt-4 mb-9">
        <ReactPaginate
          onPageChange={(e) => {
            const redirectPage = Number.parseInt(e.selected) + 1;
            navigate(
              `/parcelRates?${queryString.stringify(getQueryParamsByPage(redirectPage))}`,
            );
          }}
          forcePage={Number.parseInt(params.page) - 1 || 0}
          pageCount={totalPages}
          pageRangeDisplayed={4}
          marginPagesDisplayed={2}
          containerClassName={classNames(
            'flex flex-row w-1/2 float-left my-0 text-sm xl:text-sm',
          )}
          activeLinkClassName="!text-blue-400 !border-blue-400"
          pageLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
          previousLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
          nextLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
        />
      </div>
      <br />
      <div className="flex justify-end item-bottom">
        <div className="inline-block text-center">
          <div className="text-sm text-yellow-600 min-h-6"></div>
          <div
            onClick={() => clearTable()}
            className={classNames(
              'text-white inline-block px-4 rounded-full mx-5 mb-5',
              !isReadyToSave() ? 'bg-gray-400' : 'bg-blue-900 cursor-pointer',
            )}
          >
            Clear
          </div>
        </div>
        <div className="inline-block text-center min-w-44">
          <div
            className={classNames(
              'text-sm text-yellow-600 min-h-6',
              updateTableLoading && 'text-transparent',
            )}
          >
            {/* {isReadyToSave() ? 'No changes to save' : ''} */}
          </div>
          <div
            onClick={updateRates}
            className={classNames(
              'text-white inline-block rounded-full mx-5 mb-5 flex items-center justify-center',
              !isReadyToSave() ? 'bg-gray-500' : 'bg-red-900 cursor-pointer',
              updateTableLoading && 'bg-transparent',
            )}
          >
            {!updateTableLoading ? (
              'Save Changes'
            ) : (
              <img src={loadingGif} className="w-5 h-5" />
            )}
          </div>
        </div>
      </div>
      <div className="relative">
        <div className="w-full mb-10 relative">
          {pageLoading ? (
            <>
              <div className="flex items-center justify-center">
                <img src={loadingGif} className="w-6 h-6" />
              </div>
            </>
          ) : (
            <Table
              stickyHeaders={true}
              rowsClassName="!text-center border-b border-blue-300"
              headersClassNames="!text-center !bg-white"
              containerClassName="text-[0.9rem] whitespace-nowrap text-center"
              data={transformData(data)}
              headers={headers}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ParcelRatesEditTable;
